<template>
  <div v-if="npc" class="d-flex flex-column align-center">
    <div id="avatar">
      <AbstractNPC :avatar="npc.avatar" :height="100" :width="100" class="mx-auto animated-avatar" />
    </div>
    <div>
      {{ npc.name }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
    AbstractNPC: () => ({
      component: import(
        /* webpackChunkName: "component-abstract-npc" */ "@/components/npc/AbstractNPC"
      ),
    }),
  },
  computed: mapState({
    //
  }),
  props: [
    //
  ],
  data: () => ({
    npc: null,
  }),
  created() {
    //
  },
  mounted() {
    this.randomize();
  },
  methods: {
    remove() {
      this.npc = null;
    },
    randomize() {
      const showChance = Math.random(); // 0 to <1
      if (showChance < 0.9) {
        this.npc = null; // 90% chance
        return;
      }
      
      const npcList = [
        {
          name: "Katy",
          avatar: '{"charKey":"mochi_v4","body":"cat","mouth":"cat","pColor":"FCE83F","hat":"","left":"","right":"","back":""}',
        },
        {
          name: "Beary",
          avatar: '{"charKey":"mochi_v4","body":"bear","mouth":"bear","pColor":"C67334","hat":"","left":"","right":"","back":""}',
        },
        {
          name: "Ruby",
          avatar: '{"charKey":"mochi_v4","body":"rabbit","mouth":"rabbit","pColor":"F1F1F1","hat":"","left":"","right":"","back":""}',
        },
      ];
      this.npc = npcList[Math.floor(Math.random() * npcList.length)];
    },
  }
}
</script>